const funcs = {
  getLanguage(state) {
    return state.global.lang;
  },
  getTechAccess(state) {
    return state.global.technicalAccess;
  },
  getAccessMode(state) {
    return state.global.accessMode;
  },
  getLoading(state) {
    return state.global.loading;
  }
};

export default funcs;
